<template>

  <div id="modal">
    <div class="container-fluid">
      <p class="linespace95"></p>

      <div class="row">
	<div class="col-12">
	  <div class="centertext">
	    <p class="linespace45"></p>
	    <p class="linespace65"></p>
	  </div>
	</div>
      </div>
      <div class="container">
	<div class="row">
	  <div class="col"> </div>
	  <div class="col-auto"> 
	    <div class="container-fluid">
	      <div class="row">
		<div class="col-6">
		  <div class="centerbox">
		    <router-link to="./menu2.html">
		      <div class="greenbtnL">Activation Code<br>Management</div>
		    </router-link>
		  </div>
		</div>
		<div class="col-6">
		  <div class="centerbox">
		    <router-link to="./versionchecker.html">
		      <div class="greenbtnL">Configure<br>Version Checker</div>
		    </router-link>
		  </div>
		</div>
	      </div>
	      <div class="row linespace25">
		<div class="col-6">
		  <div class="centerbox">
		    <router-link to="./firmwareupdate.html">
		      <div class="greenbtnL">Firmware Auto-Update</div>
		    </router-link>
		  </div>
		</div>
	      </div>
	    </div>
	  </div>
	  <div class="col"> </div>
	</div>
      </div>
      <p class="linespace10"></p>
      <p class="linespace45"></p>
      <p class="linespace65"></p>

    </div>
  </div>

</template>

<script setup>

import { checkMaintenance } from '../server';

checkMaintenance();

</script>

<style scoped>
</style>
